<script>
  import relatorioServico from '../relatorio.servico';
  import projetoServico from '~modulos/projeto/servico';

  import 'select2';
  import 'select2/dist/js/i18n/pt-BR';
  import 'vue-strap/dist/vue-strap-lang';

  import CabecalhoRelatorio from '~componentes/CabecalhoRelatorio.vue';
  import TelaCheia from '~componentes/TelaCheia.vue';
  
  export default {
    components: { CabecalhoRelatorio, TelaCheia },
    data() {
      return {
        filtros: {
          idProjeto: '',
          idRubrica: '',
          idSubrubrica: '',
        },
        projetos: [],
        rubricas: [],
        subrubricas: [],
        relatorio: [],
        projeto: null,
        rubrica: null, 
        subrubrica: null, 
        configuracao: this.$storage.configuracao(),
      }
    },
    methods: {
      listaDeProjetos() {
        return projetoServico
          .listaDeProjetosPermissao("RelControleItem")
          .then(projetos => {
            this.projetos = projetos;
          });
      },
      listaDeRubricas() {
        return projetoServico
          .rubricasProjeto(this.filtros.idProjeto, '')
          .then(rubricas => {
            this.rubricas = rubricas;
          });
      },
      listaDeSubrubricas() {
        this.filtros.idSubrubrica = '';

        return projetoServico
          .subrubricasProjeto(this.filtros.idProjeto, this.filtros.idRubrica, '')
          .then(subrubricas => {
            this.subrubricas = subrubricas;
          });
      },
      gerar() {
        this.relatorio = [];
        this.setarProjeto();
        this.setarRubrica();
        this.setarSubrubrica();
        
        this.$validator
          .validateAll()
          .then(valido => {
            if (!valido) throw new Error("validacao");
            
            $('#gerar').button('loading');
            
            return relatorioServico.controleItem(this.filtros);
          })
          .then(resultado => {
            this.relatorio = resultado.controles;
            
            $('#gerar').button('reset');
            
            if (this.relatorio.length === 0) {
              this.$swal('', 'Nenhum resultado encontrado.', 'info');
            } else {
              this.$nextTick(() => {
                $('html, body').animate({
                  scrollTop: $('#relatorio').offset().top
                }, 800);
              });
            }
          })
          .catch(erro => {
            $('#gerar').button('reset');

            if (erro.status === 422) {
              this.$mensagemErro(erro, erro.body.message);
            } else {
              this.$mensagemErro(erro, 'Erro ao gerar relatório.');
            }
          });
        },
        gerarExcel() {
            this.relatorio = [];
            this.setarProjeto();
            this.setarRubrica();
            this.setarSubrubrica();

            this.$validator
                .validateAll()
                .then(valido => {
                    if (!valido) throw new Error("validacao");

                    $('#gerar-excel').button('loading');

                    return relatorioServico.controleItemExcel(this.filtros);
                })
                .then(arquivo => {
                    $('#gerar-excel').button('reset');

                    if (arquivo === '') {
                        this.$swal('', 'Nenhum resultado encontrado.', 'info');
                    } else {
                        arquivo.download();
                    }
                })
                .catch(erro => {
                    $('#gerar-excel').button('reset');

                    this.$mensagemErro(erro, 'Erro ao gerar relatório.');
                });
        },
      setarProjeto() {
        const idProjeto = this.filtros.idProjeto;

        this.projeto = idProjeto ? this.projetos.find(p => p.idProjeto == idProjeto) : null; 
      },
      setarRubrica() {
        const idRubrica = this.filtros.idRubrica;

        this.rubrica = idRubrica ? this.rubricas.find(r => r.id == idRubrica) : null; 
      },
      setarSubrubrica() {
        const idSubrubrica = this.filtros.idSubrubrica;

        this.subrubrica = idSubrubrica ? this.subrubricas.find(s => s.id == idSubrubrica) : null; 
      },
      formatarNumero(valor) {
        return this.$options.filters.formatarNumero(valor);
      },
      calculaSaldo(controle) {
        return controle.valorTotal -
               controle.valorRealizado - 
               controle.valorProvisao;
      },
    },
    computed: {
      projetoSelecionado() {
        const idProjeto = this.filtros.idProjeto;
        
        return idProjeto ? this.projetos.find(projeto => projeto.idProjeto == idProjeto) : {};
      },
    },
    mounted() {
      this.$root.tituloDaPagina = `Relatório de Controle de Item`;
      this.$root.botaoAcaoTexto = 'Imprimir relatório';
      this.$root.botaoAcaoIcon = 'fa-print';
      this.$root.botaoAcaoLink = '';

      this.$root.botaoRetrocederMostrar = false;
      this.$root.botaoRetrocederRota = '';

      this.$events.on('botaoAcao', function() {
        window.print();
      });

      this.listaDeProjetos();

      const _this = this;

      $('#projeto').select2({
        theme: "bootstrap",
        placeholder: "Selecione...",
        language: "pt-BR"
      })
      .change(function(e) {
        _this.$set(_this.filtros, 'idProjeto', this.value);

        _this.filtros.idRubrica = '';
        _this.filtros.idSubrubrica = '';

        _this.listaDeRubricas();
        _this.listaDeSubrubricas();
      });
    },
    beforeDestroy() {
      this.$events.off('botaoAcao');
    }
  }
</script>

<template>
  <div :class="['wrapper wrapper-content animated', $root.animacaoPadrao]">
    <form class="hidden-print" @submit.prevent="gerar">

      <div class="ibox float-e-margins">
        <div class="ibox-content">

          <div class="row">
            <div class="col-xs-12">
              <div class="form-group required" :class="{'has-error': errors.has('projeto')}">
                <label class="control-label" for="projeto">Projeto</label>

                <select id="projeto"
                        class="form-control"
                        v-model="filtros.idProjeto"
                        data-vv-name="projeto"
                        v-validate="'required'">
                  <option value="">Selecione...</option>
                  <option :value="projeto.idProjeto" v-for="(projeto, index) in projetos">{{ projeto.nomeProjeto }}</option>
                </select>

                <p class="text-danger" v-show="errors.has('projeto')">{{ errors.first('projeto') }}</p>
              </div>
            </div>
          </div>

          <div class="row">
            <div class="col-xs-12">
              <div class="form-group">
                <label class="control-label" for="rubrica">Rubrica</label>

                <select id="rubrica"
                        class="form-control"
                        v-model="filtros.idRubrica"
                        @change="listaDeSubrubricas">
                  <option value="">Selecione...</option>
                  <option :value="rubrica.id" v-for="rubrica in rubricas">{{ rubrica.nome }}</option>
                </select>
              </div>
            </div>
          </div>

          <div class="row">
            <div class="col-xs-12">
              <div class="form-group">
                <label class="control-label" for="subrubrica">Subrubrica</label>

                <select id="subrubrica"
                        class="form-control"
                        v-model="filtros.idSubrubrica">
                  <option value="">Selecione...</option>
                  <option :value="subrubrica.id" v-for="subrubrica in subrubricas">{{ subrubrica.nome }}</option>
                </select>
              </div>
            </div>
          </div>

        </div>
      </div>

      <div class="row">
        <div class="col-xs-12">
            <div class="form-group">
                <button id="gerar"
                        type="button"
                        class="btn btn-primary"
                        @click="gerar"
                        data-loading-text="<i class='fa fa-spinner fa-pulse'></i> Gerando relatório...">
                    <i class="fa fa-line-chart"></i>
                    Gerar relatório
                </button>

                <button id="gerar-excel"
                        type="button"
                        class="btn btn-primary"
                        @click="gerarExcel"
                        data-loading-text="<i class='fa fa-spinner fa-pulse'></i> Gerando relatório...">
                    <i class="fa fa-table"></i>
                    Gerar relatório em excel
                </button>

                <tela-cheia texto="Visualizar em tela cheia"
                            icone="arrows-alt"
                            v-if="relatorio.length > 0">
                </tela-cheia>
            </div>
        </div>
      </div>
    </form>

    <cabecalho-relatorio :titulo="`Relatório de Controle de Item`" borda=""></cabecalho-relatorio>
    <div class="row" v-if="relatorio.length > 0" id="relatorio">
      <div class="col-lg-12">
        <div class="ibox float-e-margins">
          <div class="ibox-content">

            <div class="table-responsive">
              <table class="table relatorio table-condensed no-margins">
                <thead>
                  <tr>
                    <th>Projeto</th>
                    <th v-if="rubrica">Rubrica</th>
                    <th v-if="subrubrica">Subrubrica</th>
                  </tr>
                </thead>
                <tbody>
                  <tr>
                    <td>{{ projeto.nomeProjeto }}</td>
                    <td v-if="rubrica">{{ rubrica.nome }}</td>
                    <td v-if="subrubrica">{{ subrubrica.nome }}</td>
                  </tr>
                </tbody>
              </table>

              <table class="table relatorio table-bordered">
                <thead>
                  <tr>
                    <th>Código</th>
                    <th>Tipo</th>
                    <th>Rubrica - Subrubrica</th>
                    <th>Descrição</th>
                    <th>Quant. previsto</th>
                    <th>Valor unitário</th>
                    <th>Valor total</th>
                    <th>Quant. realizado</th>
                    <th>Valor realizado</th>
                    <th>Quant. provisão</th>
                    <th>Valor provisão</th>
                    <th>Saldo CI</th>
                  </tr>
                </thead>
                <tbody>
                  <tr v-for="(controle, indice) in relatorio">
                    <td>{{ controle.codigo || '---' }}</td>
                    <td>{{ controle.tipoItem || '---' }}</td>
                    <td>{{ controle.rubricaSubrubrica || '---' }}</td>
                    <td>{{ controle.descricao || '---' }}</td>
                    <td>{{ (controle.quantidade > 0) ? formatarNumero(controle.quantidade) : '---' }}</td>
                    <td>{{ (controle.valorUnitario > 0) ? formatarNumero(controle.valorUnitario) : '---' }}</td>
                    <td>{{ (controle.valorTotal > 0) ? formatarNumero(controle.valorTotal) : '---' }}</td>
                    <td>{{ (controle.qntRealizada > 0) ? formatarNumero(controle.qntRealizada) : '---' }}</td>
                    <td>{{ (controle.valorRealizado > 0) ? formatarNumero(controle.valorRealizado) : '---' }}</td>
                    <td>{{ (controle.qntProvisao > 0) ? formatarNumero(controle.qntProvisao) : '---' }}</td>
                    <td>{{ (controle.valorProvisao > 0) ? formatarNumero(controle.valorProvisao) : '---' }}</td>
                    <td>{{ formatarNumero(calculaSaldo(controle)) }}</td>
                  </tr>
                </tbody>
              </table>
            </div>

          </div>
        </div>
      </div>
    </div>
  </div>
  
</template>



// WEBPACK FOOTER //
// FrontEnd/modulos/relatorio/componentes/ControleItem.vue